import axiosInstance from '../utils/axios';

export const issueApi = {
  raiseIssue: async (data) =>
    (await axiosInstance.post('/field-officer/issues', data)).data,

  getMyIssues: async () =>
    (await axiosInstance.get('/field-officer/issues')).data,

  getAllIssues: async () =>
    (await axiosInstance.get('/super-admin/issues')).data,

  updateIssueStatus: async (issue_id, status) =>
    (await axiosInstance.put(`/super-admin/issues/${issue_id}`, { status })).data,

  addSolution: async (issue_id, solution) =>
    (await axiosInstance.post(`/super-admin/issues/${issue_id}/solution`, { solution })).data,
};
